import moment from "moment";

export default (value) => {
  if (!value) return `not_set`;

  let due_on = moment.utc(value * 1000).startOf(`day`);
  let now = moment().startOf(`day`);

  // today
  if (due_on.format(`YYYY-MM-DD`) === now.format(`YYYY-MM-DD`)) {
    return `today`;
  }

  // overdue
  if (!due_on.isAfter(now)) {
    return `overdue`;
  }

  // upcoming
  if (moment(due_on).isBefore(now.add(7, `days`))) {
    return `upcoming`;
  }

  // schedule in future
  return `scheduled`;
};
